const computeLineAggregationData = (data: any) => {
	let newData = [...data];
	// Get Average of X, divide by number of assets
	newData[0] = newData[0] / newData[1].length
	// Multiply Y values together, then subtract from 1
	newData[1] = 1 - newData[1].reduce((a: number, b: number) => a * b);
	return newData;
}

export const computeAssetAggregationData = (riskCurves: any, detail: any) => {
	// X values
	const acresX = Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][0]);
	const buildingImpactedX = Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][0]);
	const populationImpactedX = Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][0]);
	const combinedImpactX = Object.keys(riskCurves.combined_impact).map((key) => riskCurves.combined_impact[key][0]);

	// Aggregated Probabilities PlaceHolders
	let acresBurnedProb = 0, buildingImpactedProb = 0, populationImpactedProb = 0, combinedProb = 0,
		acresBurnedandBuildingImpactedandCombinednoPSPSProb = 0, acresBurnedandBuildingImpactedandCombinedPSPSProb = 0,
		populationImpactedPSPSProb = 0, populationImpactedNoPSPSProb = 0;

	// Risk Curve X,Y sets PlaceHolders
	let acresXY: any[],       buildingImpactedXY: any[],       populationImpactedXY: any[],       combinedImpactXY: any[],
		acresNoPSPSXY: any[], buildingImpactedNoPSPSXY: any[], populationImpactedNoPSPSXY: any[], combinedImpactNoPSPSXY: any[],
		acresPSPSXY: any[]  , buildingImpactedPSPSXY: any[],   populationImpactedPSPSXY: any[],   combinedImpactPSPSXY: any[];

	/**
	 * End State type keys: Unsafe, Safe, No Risk Curve
	 */
	let unsafeEndStates = ["SQ_IlnaoM8W0.3554", "SQ_QhDVUB6bd.3554", "SQ_SlzvUTo0g.3554"],
		safeEndStates = ["SQ_f8ne0wX(w.3554", "SQ_Noaps(xA8T.3554", "SQ_sGlME72F75.3554"],
		noRiskCurveEndStates = ["SQ_CtOjx7KCn.3554", "SQ_hPdsHmVU_E.3554", "SQ_m0TfKyW5Y.3554", "SQ_bN3bPNV0qt.3554", "SQ_BU4E1hvvlA.3554", "SQ_OibYL5Vv4e.3554"];
	// Aggregate probabilities to related risk curve probability types: Unsafe, Safe
	unsafeEndStates.forEach((key) => {
		populationImpactedProb = detail.result_data.sequences[key].result + populationImpactedProb;
		combinedProb = detail.result_data.sequences[key].result + combinedProb;
	});
	safeEndStates.forEach((key) => {
		buildingImpactedProb = detail.result_data.sequences[key].result + buildingImpactedProb;
		acresBurnedProb = detail.result_data.sequences[key].result + acresBurnedProb;
		combinedProb = detail.result_data.sequences[key].result + combinedProb;
	});

	/**
	 * End State type keys: NO-PSPS, PSPS
	 */
	let acresBurnedandBuildingImpactedandCombinedPSPS = ["SQ_f8ne0wX(w.3554", "SQ_SlzvUTo0g.3554"];
	let acresBurnedandBuildingImpactedandCombinedNoPSPS = ["SQ_Noaps(xA8T.3554", "SQ_QhDVUB6bd.3554", "SQ_sGlME72F75.3554", "SQ_IlnaoM8W0.3554"];
	let populationImpactedNoPSPS = ["SQ_QhDVUB6bd.3554", "SQ_IlnaoM8W0.3554"];
	let populationImpactedPSPS = ["SQ_SlzvUTo0g.3554"];
	// Aggregate probabilities to related risk curve probability types: NO-PSPS, PSPS
	acresBurnedandBuildingImpactedandCombinedNoPSPS.forEach((key) => acresBurnedandBuildingImpactedandCombinednoPSPSProb = detail.result_data.sequences[key].result + acresBurnedandBuildingImpactedandCombinednoPSPSProb);
	acresBurnedandBuildingImpactedandCombinedPSPS.forEach((key) => acresBurnedandBuildingImpactedandCombinedPSPSProb = detail.result_data.sequences[key].result + acresBurnedandBuildingImpactedandCombinedPSPSProb);
	populationImpactedNoPSPS.forEach((key) => populationImpactedNoPSPSProb = detail.result_data.sequences[key].result + populationImpactedNoPSPSProb);
	populationImpactedPSPSProb = detail.result_data.sequences[populationImpactedPSPS[0]].result;

	/**
	 * Populate Risk Curve X,Y sets, multiply Y by related aggregated probability
	 */

	// Base Curves
	acresXY = [
		acresX,
		Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][1] * acresBurnedProb)
	];
	buildingImpactedXY = [
		buildingImpactedX,
		Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][1] * buildingImpactedProb)
	];
	populationImpactedXY = [
		populationImpactedX,
		Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][1] * populationImpactedProb)
	];
	combinedImpactXY = [
		combinedImpactX,
		Object.keys(riskCurves.combined_impact).map((key) => riskCurves.combined_impact[key][1] * combinedProb)
	];

	// No PSPS / PSPS
	acresNoPSPSXY = [
		acresX,
		Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][1] * acresBurnedandBuildingImpactedandCombinednoPSPSProb)
	];
	acresPSPSXY = [
		acresX,
		Object.keys(riskCurves.acres).map((key) => riskCurves.acres[key][1] * acresBurnedandBuildingImpactedandCombinedPSPSProb)
	];
	buildingImpactedNoPSPSXY = [
		buildingImpactedX,
		Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][1] * acresBurnedandBuildingImpactedandCombinednoPSPSProb)
	];
	buildingImpactedPSPSXY = [
		buildingImpactedX,
		Object.keys(riskCurves.building_impact).map((key) => riskCurves.building_impact[key][1] * acresBurnedandBuildingImpactedandCombinedPSPSProb)
	];
	populationImpactedNoPSPSXY = [
		populationImpactedX,
		Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][1] * populationImpactedNoPSPSProb)
	];
	populationImpactedPSPSXY = [
		populationImpactedX,
		Object.keys(riskCurves.population_impact).map((key) => riskCurves.population_impact[key][1] * populationImpactedPSPSProb)
	];
	combinedImpactNoPSPSXY = [
		combinedImpactX,
		Object.keys(riskCurves.combined_impact).map((key) => riskCurves.combined_impact[key][1] * acresBurnedandBuildingImpactedandCombinednoPSPSProb)
	];
	combinedImpactPSPSXY = [
		combinedImpactX,
		Object.keys(riskCurves.combined_impact).map((key) => riskCurves.combined_impact[key][1] * acresBurnedandBuildingImpactedandCombinedPSPSProb)
	];

	return {
		acresXY,
		buildingImpactedXY,
		populationImpactedXY,
		combinedImpactXY,
		acresNoPSPSXY,
		acresPSPSXY,
		buildingImpactedNoPSPSXY,
		buildingImpactedPSPSXY,
		populationImpactedNoPSPSXY,
		populationImpactedPSPSXY,
		combinedImpactNoPSPSXY,
		combinedImpactPSPSXY
	}
}

export const constructLineAggregationData = (data: any) => {
	/**
	 * Placeholder data
	 */
	let acresXY, acresNoPSPSXY, acresPSPSXY, buildingImpactedXY, buildingImpactedNoPSPSXY, buildingImpactedPSPSXY, populationImpactedXY, populationImpactedNoPSPSXY, populationImpactedPSPSXY;
	let acres_0: any[] = [0, []], acres_nopsps_0: any[] = [0, []],  acres_psps_0: any[] = [0, []],    building_impacted_0: any[] = [0, []],  building_impacted_nopsps_0: any[] = [0, []],   building_impacted_psps_0: any[] = [0, []],     population_impacted_0: any[] = [0, []],  population_impacted_nopsps_0: any[] = [0, []],   population_impacted_psps_0: any[] = [0, []],
		acres_20: any[] = [0, []],  acres_nopsps_20: any[] = [0, []], acres_psps_20: any[] = [0, []],   building_impacted_20: any[] = [0, []], building_impacted_nopsps_20: any[] = [0, []],  building_impacted_psps_20: any[] = [0, []],    population_impacted_20: any[] = [0, []], population_impacted_nopsps_20: any[] = [0, []],  population_impacted_psps_20: any[] = [0, []],
		acres_40: any[] = [0, []],  acres_nopsps_40: any[] = [0, []], acres_psps_40: any[] = [0, []],   building_impacted_40: any[] = [0, []], building_impacted_nopsps_40: any[] = [0, []],  building_impacted_psps_40: any[] = [0, []],    population_impacted_40: any[] = [0, []], population_impacted_nopsps_40: any[] = [0, []],  population_impacted_psps_40: any[] = [0, []],
		acres_60: any[] = [0, []],  acres_nopsps_60: any[] = [0, []], acres_psps_60: any[] = [0, []],   building_impacted_60: any[] = [0, []], building_impacted_nopsps_60: any[] = [0, []],  building_impacted_psps_60: any[] = [0, []],    population_impacted_60: any[] = [0, []], population_impacted_nopsps_60: any[] = [0, []],  population_impacted_psps_60: any[] = [0, []],
		acres_80: any[] = [0, []],  acres_nopsps_80: any[] = [0, []], acres_psps_80: any[] = [0, []],   building_impacted_80: any[] = [0, []], building_impacted_nopsps_80: any[] = [0, []],  building_impacted_psps_80: any[] = [0, []],    population_impacted_80: any[] = [0, []], population_impacted_nopsps_80: any[] = [0, []],  population_impacted_psps_80: any[] = [0, []],
		acres_90: any[] = [0, []],  acres_nopsps_90: any[] = [0, []], acres_psps_90: any[] = [0, []],   building_impacted_90: any[] = [0, []], building_impacted_nopsps_90: any[] = [0, []],  building_impacted_psps_90: any[] = [0, []],    population_impacted_90: any[] = [0, []], population_impacted_nopsps_90: any[] = [0, []],  population_impacted_psps_90: any[] = [0, []],
		acres_95: any[] = [0, []],  acres_nopsps_95: any[] = [0, []], acres_psps_95: any[] = [0, []],   building_impacted_95: any[] = [0, []], building_impacted_nopsps_95: any[] = [0, []],  building_impacted_psps_95: any[] = [0, []],    population_impacted_95: any[] = [0, []], population_impacted_nopsps_95: any[] = [0, []],  population_impacted_psps_95: any[] = [0, []],
		acres_98: any[] = [0, []],  acres_nopsps_98: any[] = [0, []], acres_psps_98: any[] = [0, []],   building_impacted_98: any[] = [0, []], building_impacted_nopsps_98: any[] = [0, []],  building_impacted_psps_98: any[] = [0, []],    population_impacted_98: any[] = [0, []], population_impacted_nopsps_98: any[] = [0, []],  population_impacted_psps_98: any[] = [0, []],
		acres_100: any[] = [0, []], acres_nopsps_100: any[] = [0, []], acres_psps_100: any[] = [0, []], building_impacted_100: any[] = [0, []], building_impacted_nopsps_100: any[] = [0, []], building_impacted_psps_100: any[] = [0, []], population_impacted_100: any[] = [0, []], population_impacted_nopsps_100: any[] = [0, []], population_impacted_psps_100: any[] = [0, []];

	/**
	 * Aggregate the x for each type, subtract 1 from the y and collect as an array
	 */
	data.forEach(item => {
		acres_0[0] = parseFloat(item["acresXY"][0][0]) + acres_0[0];
		acres_0[1].push(1 - item["acresXY"][1][0]);
		acres_20[0] = parseFloat(item["acresXY"][0][1]) + acres_20[0];
		acres_20[1].push(1 - item["acresXY"][1][1]);
		acres_40[0] = parseFloat(item["acresXY"][0][2]) + acres_40[0];
		acres_40[1].push(1 - item["acresXY"][1][2]);
		acres_60[0] = parseFloat(item["acresXY"][0][3]) + acres_60[0];
		acres_60[1].push(1 - item["acresXY"][1][3]);
		acres_80[0] = parseFloat(item["acresXY"][0][4]) + acres_80[0];
		acres_80[1].push(1 - item["acresXY"][1][4]);
		acres_90[0] = parseFloat(item["acresXY"][0][5]) + acres_90[0];
		acres_90[1].push(1 - item["acresXY"][1][5]);
		acres_95[0] = parseFloat(item["acresXY"][0][6]) + acres_95[0];
		acres_95[1].push(1 - item["acresXY"][1][6]);
		acres_98[0] = parseFloat(item["acresXY"][0][7]) + acres_98[0];
		acres_98[1].push(1 - item["acresXY"][1][7]);
		acres_100[0] = parseFloat(item["acresXY"][0][8]) + acres_100[0];
		acres_100[1].push(1 - item["acresXY"][1][8]);

		acres_nopsps_0[0] = parseFloat(item["acresNoPSPSXY"][0][0]) + acres_nopsps_0[0];
		acres_nopsps_0[1].push(1 - item["acresNoPSPSXY"][1][0]);
		acres_nopsps_20[0] = parseFloat(item["acresNoPSPSXY"][0][1]) + acres_nopsps_20[0];
		acres_nopsps_20[1].push(1 - item["acresNoPSPSXY"][1][1]);
		acres_nopsps_40[0] = parseFloat(item["acresNoPSPSXY"][0][2]) + acres_nopsps_40[0];
		acres_nopsps_40[1].push(1 - item["acresNoPSPSXY"][1][2]);
		acres_nopsps_60[0] = parseFloat(item["acresNoPSPSXY"][0][3]) + acres_nopsps_60[0];
		acres_nopsps_60[1].push(1 - item["acresNoPSPSXY"][1][3]);
		acres_nopsps_80[0] = parseFloat(item["acresNoPSPSXY"][0][4]) + acres_nopsps_80[0];
		acres_nopsps_80[1].push(1 - item["acresNoPSPSXY"][1][4]);
		acres_nopsps_90[0] = parseFloat(item["acresNoPSPSXY"][0][5]) + acres_nopsps_90[0];
		acres_nopsps_90[1].push(1 - item["acresNoPSPSXY"][1][5]);
		acres_nopsps_95[0] = parseFloat(item["acresNoPSPSXY"][0][6]) + acres_nopsps_95[0];
		acres_nopsps_95[1].push(1 - item["acresNoPSPSXY"][1][6]);
		acres_nopsps_98[0] = parseFloat(item["acresNoPSPSXY"][0][7]) + acres_nopsps_98[0];
		acres_nopsps_98[1].push(1 - item["acresNoPSPSXY"][1][7]);
		acres_nopsps_100[0] = parseFloat(item["acresNoPSPSXY"][0][8]) + acres_nopsps_100[0];
		acres_nopsps_100[1].push(1 - item["acresNoPSPSXY"][1][8]);

		acres_psps_0[0] = parseFloat(item["acresPSPSXY"][0][0]) + acres_psps_0[0];
		acres_psps_0[1].push(1 - item["acresPSPSXY"][1][0]);
		acres_psps_20[0] = parseFloat(item["acresPSPSXY"][0][1]) + acres_psps_20[0];
		acres_psps_20[1].push(1 - item["acresPSPSXY"][1][1]);
		acres_psps_40[0] = parseFloat(item["acresPSPSXY"][0][2]) + acres_psps_40[0];
		acres_psps_40[1].push(1 - item["acresPSPSXY"][1][2]);
		acres_psps_60[0] = parseFloat(item["acresPSPSXY"][0][3]) + acres_psps_60[0];
		acres_psps_60[1].push(1 - item["acresPSPSXY"][1][3]);
		acres_psps_80[0] = parseFloat(item["acresPSPSXY"][0][4]) + acres_psps_80[0];
		acres_psps_80[1].push(1 - item["acresPSPSXY"][1][4]);
		acres_psps_90[0] = parseFloat(item["acresPSPSXY"][0][5]) + acres_psps_90[0];
		acres_psps_90[1].push(1 - item["acresPSPSXY"][1][5]);
		acres_psps_95[0] = parseFloat(item["acresPSPSXY"][0][6]) + acres_psps_95[0];
		acres_psps_95[1].push(1 - item["acresPSPSXY"][1][6]);
		acres_psps_98[0] = parseFloat(item["acresPSPSXY"][0][7]) + acres_psps_98[0];
		acres_psps_98[1].push(1 - item["acresPSPSXY"][1][7]);
		acres_psps_100[0] = parseFloat(item["acresPSPSXY"][0][8]) + acres_psps_100[0];
		acres_psps_100[1].push(1 - item["acresPSPSXY"][1][8]);

		building_impacted_0[0] = parseFloat(item["buildingImpactedXY"][0][0]) + building_impacted_0[0];
		building_impacted_0[1].push(1 - item["buildingImpactedXY"][1][0]);
		building_impacted_20[0] = parseFloat(item["buildingImpactedXY"][0][1]) + building_impacted_20[0];
		building_impacted_20[1].push(1 - item["buildingImpactedXY"][1][1]);
		building_impacted_40[0] = parseFloat(item["buildingImpactedXY"][0][2]) + building_impacted_40[0];
		building_impacted_40[1].push(1 - item["buildingImpactedXY"][1][2]);
		building_impacted_60[0] = parseFloat(item["buildingImpactedXY"][0][3]) + building_impacted_60[0];
		building_impacted_60[1].push(1 - item["buildingImpactedXY"][1][3]);
		building_impacted_80[0] = parseFloat(item["buildingImpactedXY"][0][4]) + building_impacted_80[0];
		building_impacted_80[1].push(1 - item["buildingImpactedXY"][1][4]);
		building_impacted_90[0] = parseFloat(item["buildingImpactedXY"][0][5]) + building_impacted_90[0];
		building_impacted_90[1].push(1 - item["buildingImpactedXY"][1][5]);
		building_impacted_95[0] = parseFloat(item["buildingImpactedXY"][0][6]) + building_impacted_95[0];
		building_impacted_95[1].push(1 - item["buildingImpactedXY"][1][6]);
		building_impacted_98[0] = parseFloat(item["buildingImpactedXY"][0][7]) + building_impacted_98[0];
		building_impacted_98[1].push(1 - item["buildingImpactedXY"][1][7]);
		building_impacted_100[0] = parseFloat(item["buildingImpactedXY"][0][8]) + building_impacted_100[0];
		building_impacted_100[1].push(1 - item["buildingImpactedXY"][1][8]);

		building_impacted_nopsps_0[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][0]) + building_impacted_nopsps_0[0];
		building_impacted_nopsps_0[1].push(1 - item["buildingImpactedNoPSPSXY"][1][0]);
		building_impacted_nopsps_20[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][1]) + building_impacted_nopsps_20[0];
		building_impacted_nopsps_20[1].push(1 - item["buildingImpactedNoPSPSXY"][1][1]);
		building_impacted_nopsps_40[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][2]) + building_impacted_nopsps_40[0];
		building_impacted_nopsps_40[1].push(1 - item["buildingImpactedNoPSPSXY"][1][2]);
		building_impacted_nopsps_60[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][3]) + building_impacted_nopsps_60[0];
		building_impacted_nopsps_60[1].push(1 - item["buildingImpactedNoPSPSXY"][1][3]);
		building_impacted_nopsps_80[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][4]) + building_impacted_nopsps_80[0];
		building_impacted_nopsps_80[1].push(1 - item["buildingImpactedNoPSPSXY"][1][4]);
		building_impacted_nopsps_90[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][5]) + building_impacted_nopsps_90[0];
		building_impacted_nopsps_90[1].push(1 - item["buildingImpactedNoPSPSXY"][1][5]);
		building_impacted_nopsps_95[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][6]) + building_impacted_nopsps_95[0];
		building_impacted_nopsps_95[1].push(1 - item["buildingImpactedNoPSPSXY"][1][6]);
		building_impacted_nopsps_98[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][7]) + building_impacted_nopsps_98[0];
		building_impacted_nopsps_98[1].push(1 - item["buildingImpactedNoPSPSXY"][1][7]);
		building_impacted_nopsps_100[0] = parseFloat(item["buildingImpactedNoPSPSXY"][0][8]) + building_impacted_nopsps_100[0];
		building_impacted_nopsps_100[1].push(1 - item["buildingImpactedNoPSPSXY"][1][8]);

		building_impacted_psps_0[0] = parseFloat(item["buildingImpactedPSPSXY"][0][0]) + building_impacted_psps_0[0];
		building_impacted_psps_0[1].push(1 - item["buildingImpactedPSPSXY"][1][0]);
		building_impacted_psps_20[0] = parseFloat(item["buildingImpactedPSPSXY"][0][1]) + building_impacted_psps_20[0];
		building_impacted_psps_20[1].push(1 - item["buildingImpactedPSPSXY"][1][1]);
		building_impacted_psps_40[0] = parseFloat(item["buildingImpactedPSPSXY"][0][2]) + building_impacted_psps_40[0];
		building_impacted_psps_40[1].push(1 - item["buildingImpactedPSPSXY"][1][2]);
		building_impacted_psps_60[0] = parseFloat(item["buildingImpactedPSPSXY"][0][3]) + building_impacted_psps_60[0];
		building_impacted_psps_60[1].push(1 - item["buildingImpactedPSPSXY"][1][3]);
		building_impacted_psps_80[0] = parseFloat(item["buildingImpactedPSPSXY"][0][4]) + building_impacted_psps_80[0];
		building_impacted_psps_80[1].push(1 - item["buildingImpactedPSPSXY"][1][4]);
		building_impacted_psps_90[0] = parseFloat(item["buildingImpactedPSPSXY"][0][5]) + building_impacted_psps_90[0];
		building_impacted_psps_90[1].push(1 - item["buildingImpactedPSPSXY"][1][5]);
		building_impacted_psps_95[0] = parseFloat(item["buildingImpactedPSPSXY"][0][6]) + building_impacted_psps_95[0];
		building_impacted_psps_95[1].push(1 - item["buildingImpactedPSPSXY"][1][6]);
		building_impacted_psps_98[0] = parseFloat(item["buildingImpactedPSPSXY"][0][7]) + building_impacted_psps_98[0];
		building_impacted_psps_98[1].push(1 - item["buildingImpactedPSPSXY"][1][7]);
		building_impacted_psps_100[0] = parseFloat(item["buildingImpactedPSPSXY"][0][8]) + building_impacted_psps_100[0];
		building_impacted_psps_100[1].push(1 - item["buildingImpactedPSPSXY"][1][8]);

		population_impacted_0[0] = parseFloat(item["populationImpactedXY"][0][0]) + population_impacted_0[0];
		population_impacted_0[1].push(1 - item["populationImpactedXY"][1][0]);
		population_impacted_20[0] = parseFloat(item["populationImpactedXY"][0][1]) + population_impacted_20[0];
		population_impacted_20[1].push(1 - item["populationImpactedXY"][1][1]);
		population_impacted_40[0] = parseFloat(item["populationImpactedXY"][0][2]) + population_impacted_40[0];
		population_impacted_40[1].push(1 - item["populationImpactedXY"][1][2]);
		population_impacted_60[0] = parseFloat(item["populationImpactedXY"][0][3]) + population_impacted_60[0];
		population_impacted_60[1].push(1 - item["populationImpactedXY"][1][3]);
		population_impacted_80[0] = parseFloat(item["populationImpactedXY"][0][4]) + population_impacted_80[0];
		population_impacted_80[1].push(1 - item["populationImpactedXY"][1][4]);
		population_impacted_90[0] = parseFloat(item["populationImpactedXY"][0][5]) + population_impacted_90[0];
		population_impacted_90[1].push(1 - item["populationImpactedXY"][1][5]);
		population_impacted_95[0] = parseFloat(item["populationImpactedXY"][0][6]) + population_impacted_95[0];
		population_impacted_95[1].push(1 - item["populationImpactedXY"][1][6]);
		population_impacted_98[0] = parseFloat(item["populationImpactedXY"][0][7]) + population_impacted_98[0];
		population_impacted_98[1].push(1 - item["populationImpactedXY"][1][7]);
		population_impacted_100[0] = parseFloat(item["populationImpactedXY"][0][8]) + population_impacted_100[0];
		population_impacted_100[1].push(1 - item["populationImpactedXY"][1][8]);

		population_impacted_nopsps_0[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][0]) + population_impacted_nopsps_0[0];
		population_impacted_nopsps_0[1].push(1 - item["populationImpactedNoPSPSXY"][1][0]);
		population_impacted_nopsps_20[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][1]) + population_impacted_nopsps_20[0];
		population_impacted_nopsps_20[1].push(1 - item["populationImpactedNoPSPSXY"][1][1]);
		population_impacted_nopsps_40[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][2]) + population_impacted_nopsps_40[0];
		population_impacted_nopsps_40[1].push(1 - item["populationImpactedNoPSPSXY"][1][2]);
		population_impacted_nopsps_60[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][3]) + population_impacted_nopsps_60[0];
		population_impacted_nopsps_60[1].push(1 - item["populationImpactedNoPSPSXY"][1][3]);
		population_impacted_nopsps_80[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][4]) + population_impacted_nopsps_80[0];
		population_impacted_nopsps_80[1].push(1 - item["populationImpactedNoPSPSXY"][1][4]);
		population_impacted_nopsps_90[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][5]) + population_impacted_nopsps_90[0];
		population_impacted_nopsps_90[1].push(1 - item["populationImpactedNoPSPSXY"][1][5]);
		population_impacted_nopsps_95[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][6]) + population_impacted_nopsps_95[0];
		population_impacted_nopsps_95[1].push(1 - item["populationImpactedNoPSPSXY"][1][6]);
		population_impacted_nopsps_98[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][7]) + population_impacted_nopsps_98[0];
		population_impacted_nopsps_98[1].push(1 - item["populationImpactedNoPSPSXY"][1][7]);
		population_impacted_nopsps_100[0] = parseFloat(item["populationImpactedNoPSPSXY"][0][8]) + population_impacted_nopsps_100[0];
		population_impacted_nopsps_100[1].push(1 - item["populationImpactedNoPSPSXY"][1][8]);

		population_impacted_psps_0[0] = parseFloat(item["populationImpactedPSPSXY"][0][0]) + population_impacted_psps_0[0];
		population_impacted_psps_0[1].push(1 - item["populationImpactedPSPSXY"][1][0]);
		population_impacted_psps_20[0] = parseFloat(item["populationImpactedPSPSXY"][0][1]) + population_impacted_psps_20[0];
		population_impacted_psps_20[1].push(1 - item["populationImpactedPSPSXY"][1][1]);
		population_impacted_psps_40[0] = parseFloat(item["populationImpactedPSPSXY"][0][2]) + population_impacted_psps_40[0];
		population_impacted_psps_40[1].push(1 - item["populationImpactedPSPSXY"][1][2]);
		population_impacted_psps_60[0] = parseFloat(item["populationImpactedPSPSXY"][0][3]) + population_impacted_psps_60[0];
		population_impacted_psps_60[1].push(1 - item["populationImpactedPSPSXY"][1][3]);
		population_impacted_psps_80[0] = parseFloat(item["populationImpactedPSPSXY"][0][4]) + population_impacted_psps_80[0];
		population_impacted_psps_80[1].push(1 - item["populationImpactedPSPSXY"][1][4]);
		population_impacted_psps_90[0] = parseFloat(item["populationImpactedPSPSXY"][0][5]) + population_impacted_psps_90[0];
		population_impacted_psps_90[1].push(1 - item["populationImpactedPSPSXY"][1][5]);
		population_impacted_psps_95[0] = parseFloat(item["populationImpactedPSPSXY"][0][6]) + population_impacted_psps_95[0];
		population_impacted_psps_95[1].push(1 - item["populationImpactedPSPSXY"][1][6]);
		population_impacted_psps_98[0] = parseFloat(item["populationImpactedPSPSXY"][0][7]) + population_impacted_psps_98[0];
		population_impacted_psps_98[1].push(1 - item["populationImpactedPSPSXY"][1][7]);
		population_impacted_psps_100[0] = parseFloat(item["populationImpactedPSPSXY"][0][8]) + population_impacted_psps_100[0];
		population_impacted_psps_100[1].push(1 - item["populationImpactedPSPSXY"][1][8]);
	});
	acres_0 = computeLineAggregationData(acres_0);
	acres_20 = computeLineAggregationData(acres_20);
	acres_40 = computeLineAggregationData(acres_40);
	acres_60 = computeLineAggregationData(acres_60);
	acres_80 = computeLineAggregationData(acres_80);
	acres_90 = computeLineAggregationData(acres_90);
	acres_95 = computeLineAggregationData(acres_95);
	acres_98 = computeLineAggregationData(acres_98);
	acres_100 = computeLineAggregationData(acres_100);

	acres_nopsps_0 = computeLineAggregationData(acres_nopsps_0);
	acres_nopsps_20 = computeLineAggregationData(acres_nopsps_20);
	acres_nopsps_40 = computeLineAggregationData(acres_nopsps_40);
	acres_nopsps_60 = computeLineAggregationData(acres_nopsps_60);
	acres_nopsps_80 = computeLineAggregationData(acres_nopsps_80);
	acres_nopsps_90 = computeLineAggregationData(acres_nopsps_90);
	acres_nopsps_95 = computeLineAggregationData(acres_nopsps_95);
	acres_nopsps_98 = computeLineAggregationData(acres_nopsps_98);
	acres_nopsps_100 = computeLineAggregationData(acres_nopsps_100);

	acres_psps_0 = computeLineAggregationData(acres_psps_0);
	acres_psps_20 = computeLineAggregationData(acres_psps_20);
	acres_psps_40 = computeLineAggregationData(acres_psps_40);
	acres_psps_60 = computeLineAggregationData(acres_psps_60);
	acres_psps_80 = computeLineAggregationData(acres_psps_80);
	acres_psps_90 = computeLineAggregationData(acres_psps_90);
	acres_psps_95 = computeLineAggregationData(acres_psps_95);
	acres_psps_98 = computeLineAggregationData(acres_psps_98);
	acres_psps_100 = computeLineAggregationData(acres_psps_100);

	building_impacted_0 = computeLineAggregationData(building_impacted_0);
	building_impacted_20 = computeLineAggregationData(building_impacted_20);
	building_impacted_40 = computeLineAggregationData(building_impacted_40);
	building_impacted_60 = computeLineAggregationData(building_impacted_60);
	building_impacted_80 = computeLineAggregationData(building_impacted_80);
	building_impacted_90 = computeLineAggregationData(building_impacted_90);
	building_impacted_95 = computeLineAggregationData(building_impacted_95);
	building_impacted_98 = computeLineAggregationData(building_impacted_98);
	building_impacted_100 = computeLineAggregationData(building_impacted_100);

	building_impacted_nopsps_0 = computeLineAggregationData(building_impacted_nopsps_0);
	building_impacted_nopsps_20 = computeLineAggregationData(building_impacted_nopsps_20);
	building_impacted_nopsps_40 = computeLineAggregationData(building_impacted_nopsps_40);
	building_impacted_nopsps_60 = computeLineAggregationData(building_impacted_nopsps_60);
	building_impacted_nopsps_80 = computeLineAggregationData(building_impacted_nopsps_80);
	building_impacted_nopsps_90 = computeLineAggregationData(building_impacted_nopsps_90);
	building_impacted_nopsps_95 = computeLineAggregationData(building_impacted_nopsps_95);
	building_impacted_nopsps_98 = computeLineAggregationData(building_impacted_nopsps_98);
	building_impacted_nopsps_100 = computeLineAggregationData(building_impacted_nopsps_100);

	building_impacted_psps_0 = computeLineAggregationData(building_impacted_psps_0);
	building_impacted_psps_20 = computeLineAggregationData(building_impacted_psps_20);
	building_impacted_psps_40 = computeLineAggregationData(building_impacted_psps_40);
	building_impacted_psps_60 = computeLineAggregationData(building_impacted_psps_60);
	building_impacted_psps_80 = computeLineAggregationData(building_impacted_psps_80);
	building_impacted_psps_90 = computeLineAggregationData(building_impacted_psps_90);
	building_impacted_psps_95 = computeLineAggregationData(building_impacted_psps_95);
	building_impacted_psps_98 = computeLineAggregationData(building_impacted_psps_98);
	building_impacted_psps_100 = computeLineAggregationData(building_impacted_psps_100);

	population_impacted_0 = computeLineAggregationData(population_impacted_0);
	population_impacted_20 = computeLineAggregationData(population_impacted_20);
	population_impacted_40 = computeLineAggregationData(population_impacted_40);
	population_impacted_60 = computeLineAggregationData(population_impacted_60);
	population_impacted_80 = computeLineAggregationData(population_impacted_80);
	population_impacted_90 = computeLineAggregationData(population_impacted_90);
	population_impacted_95 = computeLineAggregationData(population_impacted_95);
	population_impacted_98 = computeLineAggregationData(population_impacted_98);
	population_impacted_100 = computeLineAggregationData(population_impacted_100);

	population_impacted_nopsps_0 = computeLineAggregationData(population_impacted_nopsps_0);
	population_impacted_nopsps_20 = computeLineAggregationData(population_impacted_nopsps_20);
	population_impacted_nopsps_40 = computeLineAggregationData(population_impacted_nopsps_40);
	population_impacted_nopsps_60 = computeLineAggregationData(population_impacted_nopsps_60);
	population_impacted_nopsps_80 = computeLineAggregationData(population_impacted_nopsps_80);
	population_impacted_nopsps_90 = computeLineAggregationData(population_impacted_nopsps_90);
	population_impacted_nopsps_95 = computeLineAggregationData(population_impacted_nopsps_95);
	population_impacted_nopsps_98 = computeLineAggregationData(population_impacted_nopsps_98);
	population_impacted_nopsps_100 = computeLineAggregationData(population_impacted_nopsps_100);

	population_impacted_psps_0 = computeLineAggregationData(population_impacted_psps_0);
	population_impacted_psps_20 = computeLineAggregationData(population_impacted_psps_20);
	population_impacted_psps_40 = computeLineAggregationData(population_impacted_psps_40);
	population_impacted_psps_60 = computeLineAggregationData(population_impacted_psps_60);
	population_impacted_psps_80 = computeLineAggregationData(population_impacted_psps_80);
	population_impacted_psps_90 = computeLineAggregationData(population_impacted_psps_90);
	population_impacted_psps_95 = computeLineAggregationData(population_impacted_psps_95);
	population_impacted_psps_98 = computeLineAggregationData(population_impacted_psps_98);
	population_impacted_psps_100 = computeLineAggregationData(population_impacted_psps_100);

	acresXY = [
		[acres_0[0], acres_20[0], acres_40[0], acres_60[0], acres_80[0], acres_90[0], acres_95[0], acres_98[0], acres_100[0]],
		[acres_0[1], acres_20[1], acres_40[1], acres_60[1], acres_80[1], acres_90[1], acres_95[1], acres_98[1], acres_100[1]],
	]
	acresNoPSPSXY = [
		[acres_nopsps_0[0], acres_nopsps_20[0], acres_nopsps_40[0], acres_nopsps_60[0], acres_nopsps_80[0], acres_nopsps_90[0], acres_nopsps_95[0], acres_nopsps_98[0], acres_nopsps_100[0]],
		[acres_nopsps_0[1], acres_nopsps_20[1], acres_nopsps_40[1], acres_nopsps_60[1], acres_nopsps_80[1], acres_nopsps_90[1], acres_nopsps_95[1], acres_nopsps_98[1], acres_nopsps_100[1]],
	]
	acresPSPSXY = [
		[acres_psps_0[0], acres_psps_20[0], acres_psps_40[0], acres_psps_60[0], acres_psps_80[0], acres_psps_90[0], acres_psps_95[0], acres_psps_98[0], acres_psps_100[0]],
		[acres_psps_0[1], acres_psps_20[1], acres_psps_40[1], acres_psps_60[1], acres_psps_80[1], acres_psps_90[1], acres_psps_95[1], acres_psps_98[1], acres_psps_100[1]],
	]
	buildingImpactedXY = [
		[building_impacted_0[0], building_impacted_20[0], building_impacted_40[0], building_impacted_60[0], building_impacted_80[0], building_impacted_90[0], building_impacted_95[0], building_impacted_98[0], building_impacted_100[0]],
		[building_impacted_0[1], building_impacted_20[1], building_impacted_40[1], building_impacted_60[1], building_impacted_80[1], building_impacted_90[1], building_impacted_95[1], building_impacted_98[1], building_impacted_100[1]],
	]
	buildingImpactedNoPSPSXY = [
		[building_impacted_nopsps_0[0], building_impacted_nopsps_20[0], building_impacted_nopsps_40[0], building_impacted_nopsps_60[0], building_impacted_nopsps_80[0], building_impacted_nopsps_90[0], building_impacted_nopsps_95[0], building_impacted_nopsps_98[0], building_impacted_nopsps_100[0]],
		[building_impacted_nopsps_0[1], building_impacted_nopsps_20[1], building_impacted_nopsps_40[1], building_impacted_nopsps_60[1], building_impacted_nopsps_80[1], building_impacted_nopsps_90[1], building_impacted_nopsps_95[1], building_impacted_nopsps_98[1], building_impacted_nopsps_100[1]],
	]
	buildingImpactedPSPSXY = [
		[building_impacted_psps_0[0], building_impacted_psps_20[0], building_impacted_psps_40[0], building_impacted_psps_60[0], building_impacted_psps_80[0], building_impacted_psps_90[0], building_impacted_psps_95[0], building_impacted_psps_98[0], building_impacted_psps_100[0]],
		[building_impacted_psps_0[1], building_impacted_psps_20[1], building_impacted_psps_40[1], building_impacted_psps_60[1], building_impacted_psps_80[1], building_impacted_psps_90[1], building_impacted_psps_95[1], building_impacted_psps_98[1], building_impacted_psps_100[1]],
	]
	populationImpactedXY = [
		[population_impacted_0[0], population_impacted_20[0], population_impacted_40[0], population_impacted_60[0], population_impacted_80[0], population_impacted_90[0], population_impacted_95[0], population_impacted_98[0], population_impacted_100[0]],
		[population_impacted_0[1], population_impacted_20[1], population_impacted_40[1], population_impacted_60[1], population_impacted_80[1], population_impacted_90[1], population_impacted_95[1], population_impacted_98[1], population_impacted_100[1]],
	]
	populationImpactedNoPSPSXY = [
		[population_impacted_nopsps_0[0], population_impacted_nopsps_20[0], population_impacted_nopsps_40[0], population_impacted_nopsps_60[0], population_impacted_nopsps_80[0], population_impacted_nopsps_90[0], population_impacted_nopsps_95[0], population_impacted_nopsps_98[0], population_impacted_nopsps_100[0]],
		[population_impacted_nopsps_0[1], population_impacted_nopsps_20[1], population_impacted_nopsps_40[1], population_impacted_nopsps_60[1], population_impacted_nopsps_80[1], population_impacted_nopsps_90[1], population_impacted_nopsps_95[1], population_impacted_nopsps_98[1], population_impacted_nopsps_100[1]],
	]
	populationImpactedPSPSXY = [
		[population_impacted_psps_0[0], population_impacted_psps_20[0], population_impacted_psps_40[0], population_impacted_psps_60[0], population_impacted_psps_80[0], population_impacted_psps_90[0], population_impacted_psps_95[0], population_impacted_psps_98[0], population_impacted_psps_100[0]],
		[population_impacted_psps_0[1], population_impacted_psps_20[1], population_impacted_psps_40[1], population_impacted_psps_60[1], population_impacted_psps_80[1], population_impacted_psps_90[1], population_impacted_psps_95[1], population_impacted_psps_98[1], population_impacted_psps_100[1]],
	]

	return {
		acresXY,
		acresNoPSPSXY,
		acresPSPSXY,
		buildingImpactedXY,
		buildingImpactedNoPSPSXY,
		buildingImpactedPSPSXY,
		populationImpactedXY,
		populationImpactedNoPSPSXY,
		populationImpactedPSPSXY,
	}
}